// src/features/participants/page/PolicyHolderForm.tsx
import { CATEGORY_OPTIONS, GENDER_OPTIONS, MARITAL_STATUS_OPTIONS } from '@/common/staticData/options';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';
import { checkNationalIDNo } from '@/common/services/realTimeCheckAPI';
import { useRouter } from "@tanstack/react-router";
import { useTranslation } from 'react-i18next';
export default function PolicyHolderForm() {
    const { t, i18n } = useTranslation();
    const { state } = useRouter().state.location;
    const record = (state as { record?: Record<string, unknown> })?.record;
    //const id = record?.id?.toString();
    //console.log("record", record);
    const isArabic = i18n.language === 'ar';
    const policyHolderFormSchema: DynamicFormSchema = {
        layout: 'vertical', // Overall form layout
        // submitButtonText: 'Save User', // Custom text for the submit button
        showResetButton: true, // Show a reset button

        // Define form sections for better organization and complex layouts
        sections: [
            {
                key: 'policyHolder-other',
                title: t('Policy Holder Type'),
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        "name": "userType",
                        "label": "User Type",
                        "type": "radio",
                        "colSpan": 0,
                        // disableOnEdit: true,
                        hidden: true,
                        disabled: true,
                        "defaultValue": "CM", // Default value for the radio group
                        "options": [
                            { "label": t("Individual"), "value": "IN" },
                            { "label": t("Company"), "value": "CM" }
                        ],
                    },
                    {
                        name: 'customerId',
                        label: t('Customer'),
                        type: 'select',
                        colSpan: 12, // Full width
                        disableOnEdit: true,
                        required: true,
                        requiredMessage: 'Please select a customer.', // Custom required message
                        placeholder: "Select customer",
                        options: [], // Keep this empty as options will be dynamic
                        dynamicOptions: { // Configuration for fetching options from an API
                            url: "/Lookup/GetDropdownData", // Your API endpoint for skills (ensure it returns an array of objects like {id: 1, name: "JavaScript"})
                            method: "POST", // HTTP method for the request
                            body: { "dropdowns": ["customer"] },
                            // JavaScript function string to transform the API response into { label, value } format
                            transformData: "(apiResponse) => apiResponse.customer.map(item => ({ label: item.Name, value: item.Id }))"
                        }
                    },
                    {
                        name: 'companyId',
                        label: t('Company'),
                        type: 'select',
                        colSpan: 12, // Full width
                        disableOnEdit: true,
                        required: [{ "field": "userType", "operator": "===", "value": "CM" }],
                        requiredMessage: 'Please select a company.', // Custom required message
                        placeholder: t("Select Company"),
                        dependencies: [
                            { "field": "userType", "operator": "===", "value": "CM" },
                        ],
                        options: [], // Keep this empty as options will be dynamic
                        dynamicOptions: {
                            url: "/Company/GetByCustomerId",
                            method: 'GET',
                            transformData: "(apiResponse) => apiResponse.map(item => ({ label: item.name, value: item.id }))",
                            dependsOn: ['customerId'],
                        },
                    },
                    {
                        name: 'Category',
                        label: t('Category'),
                        required: [{ "field": "userType", "operator": "===", "value": "CM" }],
                        requiredMessage: 'Select Category',
                        type: 'select',
                        options: CATEGORY_OPTIONS,
                        colSpan: 12,

                    },
                ],
            },
            {
                key: 'policyHolder-personal',
                title: t('Personal Information'),
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    //{
                    //    name: 'nameTitle', label: t('Title'), placeholder: 'Mr. Ms. Mrs.', required: true, requiredMessage: 'Select title',
                    //    type: 'select',
                    //    options: TITLE_OPTIONS,
                    //    colSpan: 12
                    //},
                    {
                        name: 'Name', label: t('Name'), type: 'input', required: true, colSpan: 12,
                        // pattern: 'AlphabetsWithSpaceEngAr',
                        validation: [
                            { max: 150, message: t('Name cannot be more than 150 characters long') },
                        ],

                    },
                    //{
                    //    name: 'mName', label: t('Middle Name'), type: 'input', colSpan: 12,
                    //    pattern: 'AlphabetsWithOutSpaceEngAr',
                    //    validation: [
                    //        { max: 100, message: t('Middle Name cannot be more than 50 characters long.') },
                    //    ],
                    //},
                    //{
                    //    name: 'lastName', label: t('Last Name'), type: 'input', required: true, colSpan: 12,
                    //    pattern: 'AlphabetsWithOutSpaceEngAr',
                    //    validation: [
                    //        { max: 50, message: t('Last Name cannot be more than 50 characters long.') },
                    //    ],
                    //},

                    { name: 'dob', label: t('Date of Birth'), type: 'date', required: true, colSpan: 12, disabledDateFunction: '(current) => current && current > dayjs().endOf(\'day\')' },
                    {
                        name: 'gender',
                        label: 'Gender',
                        required: true, requiredMessage: t('Select gender'),
                        type: 'select',
                        options: GENDER_OPTIONS,
                        colSpan: 12,
                    },
                    {
                        name: 'maritalStatus',
                        label: t('Marital Status'),
                        //required: true, requiredMessage: t('Select marital status'),
                        type: 'select',
                        options: MARITAL_STATUS_OPTIONS,
                        colSpan: 12,
                    },
                    {
                        name: 'nationalIDNo',
                        label: t('National ID No'),
                        type: 'input',
                        //required: true,
                        //requiredMessage: t('National Id# is required'),
                        //disabledWhen: [
                        //    {
                        //        field: 'companyId',
                        //        operator: 'isFalsy',
                        //    },
                        //],
                        //dependencies: [
                        //    { "field": "userType", "operator": "===", "value": "CM" }
                        //],
                        colSpan: 12,
                        pattern: 'NationalID',
                        validation: [
                            { max: 20, message: t('National ID No cannot be more than 20 characters long.') },
                            ({ getFieldValue }) => ({
                                async validator(_, value) {

                                    if (!value) return Promise.resolve();
                                    if (value.length < 3) return Promise.resolve(); // Don't call API if less than 5 chars


                                    const userType = getFieldValue('userType');
                                    const companyId = userType === 'CM'
                                        ? getFieldValue('companyId') ?? 0
                                        : 0; // In Individual case  companyId = 0

                                    // if company type exist but companyId is not selected → skip API call
                                    if (userType === "CM" && !companyId) {
                                        return Promise.resolve();
                                    }

                                    try {
                                        const result = await checkNationalIDNo(
                                            value,
                                            companyId ? Number(companyId) : record?.companyId ? Number(record.companyId) : undefined,
                                            record?.id ? Number(record.id) : undefined
                                        );
                                        if (result.exists) {
                                            return Promise.reject('National ID No already exists.');
                                        }
                                        return Promise.resolve();
                                    } catch (error: any) {
                                        console.error('Error validating National ID No:', error);
                                        return Promise.reject(error.message || 'Error validating National ID No.');
                                    }

                                },

                            }),
                        ],

                    },
                    {
                        name: 'passportNo', label: t('Passport No'), type: 'input', colSpan: 12,
                        pattern: 'AlphaNumeric',
                        validation: [
                            { max: 20, message: t('Passport No. cannot be more than 20 characters long.') },
                        ],
                    },
                    {
                        name: 'poBoxNo', label: t('PO Box No'), type: 'input', colSpan: 12,
                        validation: [
                            { max: 20, message: t('PO Box No cannot be more than 20 characters long.') },
                        ],
                    },
                ],
            },
            {
                key: 'policyHolder-contact',
                title: t('Contact Information'),
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        name: 'mobileNo', label: t('Mobile Number'), type: 'input', colSpan: 12,
                        pattern: 'PhoneNumber',
                    },
                    {
                        name: t('phoneNo'), label: 'Phone Number', type: 'input', colSpan: 12,
                        pattern: 'PhoneNumber',
                    },
                    {
                        name: 'officePhoneNo', label: t('Office Phone Number'), type: 'input', colSpan: 12,
                        pattern: 'PhoneNumber',
                    },
                    {
                        name: 'officeEmail', label: t('Office Email'), type: 'input', colSpan: 12,
                        pattern: 'Email',
                    },
                    {
                        name: 'officeFaxNo', label: t('Office Fax'), type: 'input', colSpan: 12,
                        pattern: 'OnlyDigits',
                        //required: true,
                        //requiredMessage: 'Office Fax Number cannot be more than 15 characters long',
                        validation: [
                            { max: 15, message: t('Office Fax Number cannot be more than 15 characters long') },
                        ],
                    },
                    {
                        name: 'officeJoiningDate', label: t('Office Joining Date'), type: 'date', colSpan: 12,
                    },
                ],
            },
            {
                key: 'policyHolder-address',
                title: t('Address Information'),
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        name: 'countryId',
                        label: t('Country'),
                        type: 'select',
                        colSpan: 12, // Full width
                        placeholder: "Select country",
                        required: true,
                        requiredMessage: t("Country is required."),
                        showSearch: true, // Enable search functionality
                        options: [], // Will be filled dynamically
                        defaultValue: 104, // <-- Set Iraq as default
                        dynamicOptions: {
                            url: "/Lookup/GetDropdownData",
                            method: "POST",
                            body: { "dropdowns": ["country"] },
                            transformData: `(apiResponse) => apiResponse.country.map(item => ({ label: ${isArabic ? 'item.NameAr' : 'item.Name'}, value: item.Id }))`,

                        },
                    },
                    {
                        name: 'cityId',
                        label: t('City'),
                        type: 'select',
                        //required: true,
                        //requiredMessage: t('City is required.'),
                        showSearch: true, // Enable search functionality
                        colSpan: 12,
                        options: [],
                        dynamicOptions: {
                            url: "/City/SearchByCountryId",
                            method: 'GET',
                            //transformData: "(apiResponse) => apiResponse.map(item => ({ label: item.name, value: item.id }))",
                            transformData: `(apiResponse) => apiResponse.map(item => ({ label: ${isArabic ? 'item.nameAr' : 'item.name'}, value: item.id }))`,
                            dependsOn: ['countryId'],
                        },
                        disabledWhen: [
                            {
                                field: 'countryId',
                                operator: 'isFalsy',
                            },
                        ],
                    },
                    //{
                    //    name: 'cityId',
                    //    label: 'City',
                    //    type: 'select',
                    //    colSpan: 12, // Full width
                    //    placeholder: "Select city",
                    //    options: [], // Keep this empty as options will be dynamic
                    //    dynamicOptions: { // Configuration for fetching options from an API
                    //        url: "https://insurance-staging-api.altaifgroup.com/api/Lookup/GetDropdownData", // Your API endpoint for skills (ensure it returns an array of objects like {id: 1, name: "JavaScript"})
                    //        method: "POST", // HTTP method for the request
                    //        body: { "dropdowns": ["city"] },
                    //        // JavaScript function string to transform the API response into { label, value } format
                    //        transformData: "(apiResponse) => apiResponse.city.map(item => ({ label: item.Name, value: item.Id }))"
                    //    },
                    //},
                    {
                        name: 'area', label: t('Area'), type: 'input', colSpan: 12,
                        pattern: 'AlphaNumericAndSomeSpecialCharEngAr',
                        validation: [
                            { max: 50, message: t('Area cannot be more than 50 characters long.') },
                        ],
                    },
                    {
                        name: 'streetNo', label: t('Street No'), type: 'input', colSpan: 12,
                        pattern: 'OnlyDigits',
                        validation: [
                            { max: 5, message: t('Street No cannot be more than 5 digits') },
                        ],
                    },
                    {
                        name: 'address', label: t('Full Address'), type: 'textarea', colSpan: 24,
                        pattern: 'AlphaNumericAndSomeSpecialCharEngAr',
                        validation: [
                            { max: 250, message: t('Address cannot be more than 250 characters long.') },
                        ],
                    },
                ],
            },
            {
                key: 'policyHolder-medical',
                title: t('Medical Information'),
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        name: 'bloodGroup',
                        label: 'Blood Group',
                        type: 'select',
                        colSpan: 12, // Full width
                        placeholder: "Select Blood Group",
                        //required: true,
                        //requiredMessage: t('Blood Group is required'),
                        options: [], // Keep this empty as options will be dynamic
                        dynamicOptions: { // Configuration for fetching options from an API
                            url: "/Lookup/GetDropdownData", // Your API endpoint for skills (ensure it returns an array of objects like {id: 1, name: "JavaScript"})
                            method: "POST", // HTTP method for the request
                            body: { "dropdowns": ["bloodgroup"] },
                            // JavaScript function string to transform the API response into { label, value } format
                            transformData: "(apiResponse) => apiResponse.bloodgroup.map(item => ({ label: item.name, value: item.id }))"
                        },
                    },
                    {
                        name: 'weight',
                        label: t('Weight'),
                        type: 'number',
                        colSpan: 6,
                        validation: [
                            {
                                validator: (_: unknown, value: number) => {

                                    if (value > 250) {
                                        return Promise.reject(new Error('Value must be less than or equal to 250'));
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ],
                        pattern: 'OnlyDecimalNumber',

                    },
                    {
                        name: 'weightUnit', label: t('Weight Unit'), type: 'input', colSpan: 6,
                        validation: [
                            { max: 10, message: t('Weight unit cannot be more than 10 characters long.') },
                            {
                                validator: (_, value) => {
                                    if (value && value.includes('.')) {
                                        const decimalPart = value.split('.')[1];
                                        if (decimalPart.length > 2) {
                                            return Promise.reject('Only up to 2 decimal places are allowed.');
                                        }
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ],
                    },
                    {
                        name: 'heightInFeets', label: t('Height (ft)'), type: 'number', colSpan: 6,
                        validation: [
                            {
                                validator: (_: unknown, value: number) => {

                                    if (value > 10) {
                                        return Promise.reject(new Error(t('Value cannot be greater than 10.')));
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ],
                        pattern: 'OnlyDecimalNumber',
                    },
                    {
                        name: 'heightInInches', label: t('Height (cm)'), type: 'number', colSpan: 6,
                        validation: [
                            {
                                validator: (_: unknown, value: number) => {

                                    if (value > 300) {
                                        return Promise.reject(new Error(t('Value cannot be greater than 300.')));
                                    }

                                    return Promise.resolve();
                                },
                            },
                        ],
                        pattern: 'OnlyDecimalNumber',
                        //min: 12, max: 300
                    },
                    {
                        name: 'allergyIntolerance', label: t('Allergy Intolerance'), type: 'textarea', colSpan: 24,
                        pattern: 'AlphabetsWithSpaceEngAr',
                        validation: [
                            { max: 200, message: t('Allergy Intolerance cannot be more than 200 characters long.') },
                        ],
                    },
                    {
                        name: 'chronicDiseases', label: t('Chronic Diseases'), type: 'textarea', colSpan: 24,
                        pattern: 'AlphabetsWithSpaceEngAr',
                        validation: [
                            { max: 200, message: t('Chronic Diseases cannot be more than 200 characters long.') },
                        ],
                    },
                    {
                        name: 'chronicMedications', label: t('Chronic Medications'), type: 'textarea', colSpan: 24,
                        validation: [
                            { max: 200, message: t('Chronic Medications cannot be more than 200 characters long.') },
                        ],
                    },
                    {
                        name: 'isFamilyCovered', label: t('Is Family Covered'), type: 'switch', colSpan: 12,
                    },
                ],
            },
            {
                key: 'policyHolder-other',
                title: t('Additional Notes'),
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        name: 'note', label: t('Notes'), type: 'textarea', colSpan: 24,
                        pattern: 'AlphaNumericAndSomeSpecialCharEngAr',
                        validation: [
                            { max: 500, message: t('Notes cannot be more than 500 characters long.') },
                        ],
                    },
                ],
            }
        ],
    };

    return (
        <DynamicForm
            schema={policyHolderFormSchema}
            submitApiUrl={API_ENDPOINTS.PARTICIPANTS.SAVE_POLICYHOLDER}
            getByIdApiUrl={API_ENDPOINTS.PARTICIPANTS.GET_POLICYHOLDER_BY_ID}
            updateApiUrl={API_ENDPOINTS.PARTICIPANTS.UPDATE_POLICYHOLDER}
            refreshTableDataKey={QUERY_KEYS.PARTICIPANTS.POLICYHOLDERS}
        />
    );
}